exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LeftSidebar-ce9fda77{height:100%;display:flex;flex-direction:column}.routeInfo-c3ef008d{padding:10px;background:#C4CEFC;font-size:15px;line-height:19px}.routeName-29edcc0a{font-weight:500;margin-bottom:2px}.metrics-d62cf494{padding:10px;font-size:13px;line-height:20px}.routeMetrics-6e1298b5>span{margin-right:16px}.title-9945625b{font-weight:500;margin-bottom:5px}\n", ""]);

// Exports
exports.locals = {
	"LeftSidebar": "LeftSidebar-ce9fda77",
	"routeInfo": "routeInfo-c3ef008d",
	"routeName": "routeName-29edcc0a",
	"metrics": "metrics-d62cf494",
	"routeMetrics": "routeMetrics-6e1298b5",
	"title": "title-9945625b"
};